export default "__VITE_ASSET__DSay5raD__"